import FieldServiceManagement from "../../../../src/pages/use-cases/page-content/content-publishing/field-service-management.md";
import * as React from 'react';
export default {
  FieldServiceManagement,
  React
};